import React from 'react';
import s from './ConstituencyWidget.scss';
import Link from '../../../components/Link/Link';

const ConstituencyWidget = props =>
  props.showStatus ? (
    <div className={s.consBox}>
      <div className={s.consBoxHead}>
        <h2 className={s.conBoxTitle}>{props.title}</h2>
        {props.showStatus && (
          <div className={s.conBoxInfoText}>
            {props.toBeDecided ? 'To Be Decided' : ''}
          </div>
        )}
      </div>
      <div className={s.consContent}>{props.children}</div>
    </div>
  ) : (
    <Link
      className={`${s.consBox} ${
        props.wrapperClass ? s[props.wrapperClass] : ''
      }`}
      to={props.link}
      doNotChangeDomain
    >
      <div className={s.consBoxHead}>
        <div className={s.conBoxTitle}>{props.title}</div>
        {props.infoText && (
          <div className={s.conBoxInfoText}>{props.infoText}</div>
        )}
      </div>
      <div className={s.consContent}>{props.children}</div>
    </Link>
  );

export default ConstituencyWidget;
